module.exports = __webpack_public_path__ + "img/ghan-thin-thumb.ef43dc5c.jpg";